import React from 'react';
import { Card, ListGroup, Badge } from 'react-bootstrap';
import { PIPELINE_STEPS } from './constants';
import { getStepStatus, getStepVariant } from './utils';

export const StepNavigation = ({ 
  currentStep, 
  stepResults, 
  stepErrors, 
  onStepClick, 
  executionOrder 
}) => {
  return (
    <Card className="mb-3">
      <Card.Header>
        <strong>🔧 Pipeline Steps</strong>
      </Card.Header>
      <Card.Body className="p-0">
        <ListGroup variant="flush">
          {PIPELINE_STEPS.map((step, index) => {
            const status = getStepStatus(index, stepResults, stepErrors);
            const variant = getStepVariant(status);
            const isActive = currentStep === index;
            const hasExecuted = executionOrder.includes(index);
            
            return (
              <ListGroup.Item
                key={index}
                action
                active={isActive}
                onClick={() => onStepClick(index)}
                className={`d-flex justify-content-between align-items-start ${isActive ? 'active' : ''}`}
                style={{ cursor: 'pointer' }}
              >
                <div className="flex-grow-1">
                  <div className="d-flex align-items-center mb-1">
                    <span className="me-2" style={{ fontSize: '1.2em' }}>
                      {step.icon}
                    </span>
                    <strong className={isActive ? 'text-white' : ''}>
                      Step {index + 1}: {step.name}
                    </strong>
                  </div>
                  <small className={isActive ? 'text-white-50' : 'text-muted'}>
                    {step.description}
                  </small>
                </div>
                <div className="d-flex flex-column align-items-end">
                  <Badge 
                    variant={variant} 
                    className={`mb-1 ${status === 'pending' ? 'badge-pending' : ''}`}
                    style={{ 
                      backgroundColor: isActive ? 'rgba(255,255,255,0.2)' : undefined,
                      border: isActive ? '1px solid rgba(255,255,255,0.5)' : undefined
                    }}
                  >
                    {status}
                  </Badge>
                  {hasExecuted && (
                    <Badge variant="info" className="small">
                      #{executionOrder.indexOf(index) + 1}
                    </Badge>
                  )}
                </div>
              </ListGroup.Item>
            );
          })}
        </ListGroup>
      </Card.Body>
    </Card>
  );
};

export const ProgressBar = ({ currentStep, stepResults, stepErrors }) => {
  const completedSteps = Object.keys(stepResults).length;
  const totalSteps = PIPELINE_STEPS.length;
  const progressPercentage = (completedSteps / totalSteps) * 100;
  const hasErrors = Object.keys(stepErrors).length > 0;

  return (
    <div className="mb-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="mb-0">Pipeline Progress</h6>
        <small className="text-muted">
          {completedSteps} of {totalSteps} steps completed
        </small>
      </div>
      <div className="progress" style={{ height: '10px' }}>
        <div
          className={`progress-bar ${hasErrors ? 'bg-warning' : 'bg-success'}`}
          role="progressbar"
          style={{ width: `${progressPercentage}%` }}
          aria-valuenow={progressPercentage}
          aria-valuemin="0"
          aria-valuemax="100"
        />
      </div>
      {hasErrors && (
        <small className="text-warning mt-1">
          ⚠️ Some steps completed with warnings
        </small>
      )}
    </div>
  );
};
